class IntlHelper {
    CurrencyFormat(value: number): string {
        let usdFormater = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        return usdFormater.format(value);
    }
}


export default IntlHelper;